<template>
  <div v-if="can('add-service')">
    <h2>Add Service</h2>
    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider name="title" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="title">Title<Astrik /></label>
              <input
                type="text"
                v-model="title"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider name="slug" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="title">Slug<Astrik /></label>
              <input
                type="text"
                v-model="slug"
                class="form-control"
                id="slug"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="time_period"
            rules="required|integer"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="title">Time Period<Astrik /></label>
              <input
                type="text"
                v-model="time_period"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <!-- <ValidationProvider
            name="image"
            rules="image"
            v-slot="{ errors, validate }"
          >
            <div class="form-group my-4">
              <label for="title">Image<Astrik /></label>
              <input
                type="file"
                @change="validate"
                accept="image/*"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider> -->

          <ValidationProvider
            name="image"
            rules="required|image"
            ref="provider"
            v-slot="{ validate, errors }"
          >
            <div class="form-group my-4">
              <label for="title">Image<Astrik /></label>

              <input
                type="file"
                class="form-control"
                @change="handleFileChange"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider name="sort" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="title">Sort<Astrik /></label>
              <input
                type="text"
                v-model="sort"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="status"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="title">Status<Astrik /></label>
              <select
                class="form-select form-select-lg mb-3"
                aria-label=".form-select-lg example"
              >
                <option
                  :value="status.value"
                  v-for="(status, index) in $store.state.status"
                  :key="index"
                >
                  {{ status.label }}
                </option>
              </select>
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <!-- <div class="button-form-group"> -->
          <button type="submit" class="btn btn-success">Submit</button>
          <!-- <button type="submit" class="btn btn-danger pull-right">
              Cancel
            </button> -->
          <!-- </div> -->
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddService",
  data() {
    return {
      submitting: false,
      title: "",
      slug: "",
      time_period: null,
      image: "",
      status: 1,
      sort: 1,
    };
  },
  mounted() {
    // if (!this.can("add-service")) {
    //   this.$router.push({
    //     name: "Dashboard",
    //   });
    // }
  },
  methods: {
    // validate(event) {
    //   console.log(event.target.files[0]);
    //   this.image = event.target.files[0];
    // },
    async handleFileChange(e) {
      const { valid } = await this.$refs.provider.validate(e);

      if (valid) {
        // TODO: Upload the file
        console.log("Uploaded the file...");
        this.image = e.target.files[0];
      }
    },
    onSubmit() {
      this.submitting = true;
      const formData = new FormData();
      formData.append("title", this.title);
      formData.append("slug", this.slug);
      formData.append("time_period", this.time_period);
      formData.append("image", this.image);
      formData.append("status", this.status);
      formData.append("sort", this.sort);

      this.$http.post("service", formData).then((res) => {
        if (res.data.status == 1) {
          this.$notify({
            group: "notifications",
            title: "Service",
            type: "success",
            text: res.data.message,
          });
          this.$router.push("/admin/service");
        } else {
          this.$notify({
            group: "notifications",
            title: res.data.message,
            type: "error",
            text: res.data.errors[0],
          });
        }
      });
      // .catch((err) => {
      //   this.errors = err.response.data.error;
      // });
    },
  },
};
</script>
